export default class ActivityIcon {

	static setRunning($icon) {
		$icon.attr('class', 'activity-icon activity-icon--running js_activity-icon');
		$icon.find('.fa').attr('class', 'fa fa-cog fa-spin');

		ActivityIcon.lastRunningId = ActivityIcon.lastRunningId || 0;
		var runningId = ++ActivityIcon.lastRunningId;
		$icon.attr('data-running-id', runningId);
		return runningId;
	}

	static setSuccess($icon, runningId) {
		if (parseInt($icon.attr('data-running-id'), 10) !== runningId) {
			return;
		}

		$icon.attr('class', 'activity-icon activity-icon--success js_activity-icon');
		$icon.find('.fa').attr('class', 'fa fa-check');

		window.setTimeout(() => {
			if (parseInt($icon.attr('data-running-id'), 10) !== runningId) {
				return;
			}

			ActivityIcon.setNone($icon);
		}, 3000);
	}

	static setNone($icon) {
		$icon.attr('class', 'activity-icon activity-icon--hidden js_activity-icon');
		$icon.find('.fa').attr('class', 'fa');

		$icon.removeAttr('data-running-id');
	}

}
